const FormTextArea = ({ style, value, event, name, placeholder, onChange }) => {
    return <textarea className={style}  name={name} placeholder={placeholder} onChange={onChange}>{value}</textarea>
}

export default FormTextArea;